<template>
  <v-container fluid>
    <v-row dense>  
      <v-col cols="12">
        <v-simple-table dense class="mt-1">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" width="20%">ID</th>
                <th class="text-left" width="15%">CODICE</th>
                <th class="text-left" width="15%">LOTTO</th>
                <th class="text-center" width="4%">UM</th>
                <th class="text-center" width="10%">QUANTITA'</th>
                <th class="text-center" width="10%">DATA</th>
                <th class="text-center" width="10%">DISTINTA MOD.</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in produzione" :key="index">
                <td class="text-left">{{ item.codice }}</td>
                <td class="text-left">{{ item.base }}</td>
                <td class="text-left">{{ item.lotto }}</td>
                <td class="text-center">{{ item.unitaMisura }}</td>
                <td class="text-center">{{ item.quantita }}</td>
                <td class="text-center">{{ item.data | dateTime }}</td>
                <td class="text-center">{{ item.distintaModificata ? 'SI': 'NO' }}</td>
              </tr>
            </tbody>                
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    props: {
      item: Object,
      trigger: { type: Number, default: 1}
    },
    data () {
      return {}
    },
    computed: {
      produzione() {
        return this.item.produzione
      }
    }
  }
</script>
